import { type Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { type Observable, scan } from 'rxjs';

/** Full forms save by mutating their item, so signal inputs need an explicit invalidation. */
export function itemChangeRevision(changed: Observable<void>): Signal<number> {
  return toSignal(changed.pipe(scan((revision) => revision + 1, 0)), { initialValue: 0 });
}
